import SiteLayout from '@/components/feature/SiteLayout';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import Hero from './components/Hero';
import Expertise from './components/Expertise';
import ServicesTabs from './components/ServicesTabs';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import BookingSection from './components/BookingSection';

export default function Home() {
  useDocumentMeta('Auto Repair & Maintenance Service | Redline Garage', 'Redline Garage delivers precise engine diagnostics, routine maintenance, brake, tire and electrical repairs with clear, itemized estimates. Request a service online.');

  return (
    <SiteLayout>
      <Hero />
      <Expertise />
      <ServicesTabs />
      <Process />
      <Testimonials />
      <BookingSection />
    </SiteLayout>
  );
}